// Product Catalog table configuration — feature-local so the shared integrations
// products components stay untouched (this config is passed in via props).

/**
 * Backend sort keys per sortable table column, keyed by the column's `id`.
 *
 * IMPORTANT: these string values must match the backend's accepted `sort_by`
 * keys. The existing catalog only documents `score_*` / `title` / `issues`, so
 * the values below follow the directioned `<field>_asc|_desc` convention as a
 * best guess — adjust here (one place) if the backend names differ.
 */
export const PRODUCT_CATALOG_HEADER_SORT: Record<string, { asc: string; desc: string }> = {
  item_group_id: { asc: 'item_group_id_asc', desc: 'item_group_id_desc' },
  gtin: { asc: 'gtin_asc', desc: 'gtin_desc' },
  mpn: { asc: 'mpn_asc', desc: 'mpn_desc' },
  brand: { asc: 'brand_asc', desc: 'brand_desc' },
  // The price column renders under the `price_amount` id.
  price_amount: { asc: 'price_asc', desc: 'price_desc' },
  age_group: { asc: 'age_group_asc', desc: 'age_group_desc' },
};

/**
 * Options for the card-view sort dropdown. Keeps the score/title/issues keys the
 * backend already supports and adds the catalog attribute fields (which map to
 * the same keys as {@link PRODUCT_CATALOG_HEADER_SORT}).
 */
export const PRODUCT_CATALOG_SORT_OPTIONS: readonly { value: string; label: string }[] = [
  { value: 'score_desc', label: 'Score ↓' },
  { value: 'score_asc', label: 'Score ↑' },
  { value: 'title', label: 'Title' },
  { value: 'issues', label: 'Issues' },
  { value: 'item_group_id_asc', label: 'Item group ID' },
  { value: 'gtin_asc', label: 'GTIN' },
  { value: 'mpn_asc', label: 'MPN' },
  { value: 'brand_asc', label: 'Brand' },
  { value: 'price_asc', label: 'Price ↑' },
  { value: 'price_desc', label: 'Price ↓' },
  { value: 'age_group_asc', label: 'Age group' },
];

/**
 * Columns shown by default in the table view; everything else is hidden until
 * toggled on via the column picker. Ids are the connector column codes.
 */
export const PRODUCT_CATALOG_DEFAULT_COLUMNS: string[] = [
  'title',
  'description',
  'country',
  'language',
  'item_group_id',
  'availability',
];
